// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"187":"cityCompany","536":"myAbout","640":"storeEnter","881":"newAsync"}[chunkId] || chunkId) + "." + {"187":"9cc043dd","357":"f53a0fe6","536":"531b3813","640":"f959cb86","881":"703c2414"}[chunkId] + ".js";
};